import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { updateUser } from '../../auth/slice';

const ProfileSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Muy corto')
    .max(30, 'Muy Largo')
    .required('Campo requerido'),
  lastname: Yup.string()
    .min(2, 'Muy corto')
    .max(30, 'Muy Largo')
    .required('Campo requerido'),
  email: Yup.string().email('Correo no válido').required('Campo requerido'),
});

const initialValues = { name: '', lastname: '', email: '' };

const Profile = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => state.auth.user);

  const formik = useFormik({
    initialValues,
    validationSchema: ProfileSchema,
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        await dispatch(
          updateUser({
            userId: profile?.uid,
            payload: values,
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    if (profile) {
      const { name, lastname, email } = profile;

      formik.setValues({
        ...formik.values,
        name: name ?? '',
        lastname: lastname ?? '',
        email: email ?? '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 4,
      }}
    >
      <Stack width="500px">
        <Typography variant="h1">Mi Perfil</Typography>
        <TextField
          name="name"
          type="text"
          label="Nombre"
          margin="normal"
          value={formik.values.name}
          onChange={formik.handleChange}
        />
        <TextField
          name="lastname"
          type="text"
          label="Apellido"
          margin="normal"
          value={formik.values.lastname}
          onChange={formik.handleChange}
        />
        <TextField
          name="email"
          type="email"
          label="Correo"
          margin="normal"
          disabled
          value={formik.values.email}
          onChange={formik.handleChange}
        />
        <Button
          size="large"
          variant="contained"
          onClick={formik.handleSubmit}
          disabled={isLoading}
        >
          Actualizar Info
        </Button>
      </Stack>
    </Box>
  );
};

export default Profile;
